module.exports = __webpack_public_path__ + "img/crypto.7788bd56.png";